export class FailedToCutOverlappingStopVersion extends Error {}
